(function () {
  function initCarousel(root) {
    var viewport = root.querySelector('.ryp-testimonials__viewport');
    var track = root.querySelector('.ryp-testimonials__track');
    var prev = root.querySelector('.ryp-testimonials__nav--prev');
    var next = root.querySelector('.ryp-testimonials__nav--next');
    var slides = track ? track.querySelectorAll('.ryp-testimonials__slide') : [];

    if (!viewport || !track || !slides.length) return;

    var index = 0;

    function getStep() {
      var slide = slides[0];
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function getPerView() {
      var step = getStep();
      if (step <= 0) return 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return Math.max(1, Math.round((viewport.getBoundingClientRect().width + gap) / step));
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - getPerView());
    }

    function update() {
      var maxIndex = getMaxIndex();
      if (index > maxIndex) index = maxIndex;
      if (index < 0) index = 0;

      track.style.transform = 'translateX(' + -(index * getStep()) + 'px)';

      var single = slides.length <= getPerView();
      if (prev) {
        prev.hidden = single;
        prev.disabled = index <= 0;
      }
      if (next) {
        next.hidden = single;
        next.disabled = index >= maxIndex;
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        index -= 1;
        update();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        index += 1;
        update();
      });
    }

    // Touch swipe support
    var startX = 0;
    var deltaX = 0;
    var dragging = false;

    viewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      deltaX = 0;
      dragging = true;
    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });

    viewport.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(deltaX) > 40) {
        index += deltaX < 0 ? 1 : -1;
        update();
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 150);
    });

    update();
  }

  function initAll(scope) {
    var sections = (scope || document).querySelectorAll('[data-section-type="ryp-testimonials"]');
    sections.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) initAll(e.target);
  });
})();
